/*
    Pre-footer.js
    - make the pre footer blocks the same height always.
 */
(function () {
    'use strict';
    var pre_footer = document.querySelectorAll('.prefooter');

    if(pre_footer){
        Array.prototype.forEach.call(pre_footer, function (item) {
            makeSameHeight(item.querySelectorAll('.prefooter-left, .prefooter-right'));
        });

        window.addEventListener('resize', function () {
            Array.prototype.forEach.call(pre_footer, function (item) {
                makeSameHeight(item.querySelectorAll('.prefooter-left, .prefooter-right'));
            });
        });
    }


    function makeSameHeight(items) {
        var max_height = 0;

        // find the highest item
        Array.prototype.forEach.call(items, function (el) {
           el.style.height ='auto';
           max_height = Math.max(max_height, el.offsetHeight);
        });
        // set the height of the highest item
        Array.prototype.forEach.call(items, function (el) {
           el.style.height = max_height + 'px';
        });
    }

}());